import { computed } from "vue";
import { useStore } from "vuex";
import type { StateType } from "@/types";
import { useRouter, useRoute } from "vue-router";
import { getToken } from "@/utils/auth";
import { formatThousand, parseThousand } from "@/utils/tools";

export default function useCommon() {
  const router = useRouter();
  const store = useStore<StateType>();

  const JumpTo = (name = "/", params = {}) => {
    router.push({ name, query: params });
    // window.scrollTo(0,0)
    // const targetRoute = router.resolve({ name,query: params}).href;
    // window.open(targetRoute, '_blank');
  };
  const JumpToHref = (name = "/", params = {}) => {
    const targetRoute = router.resolve({ name, query: params }).href;
    window.open(targetRoute, "_blank");
    // window.scrollTo(0,0)
  };

  const checkLoginAndJump = (name = "/", params = {}) => {
    const token = store.state.user.token;
    if (!token && !getToken()) {
      store.dispatch("user/setLoginShow", true);
    } else {
      JumpToHref(name, params);
    }
  };

  const checkLoginOpen = (callback: any) => {
    const token = store.state.user.token;
    if (!token && !getToken()) {
      store.dispatch("user/setLoginShow", true);
    } else {
      if (typeof callback == "function") callback();
    }
  };

  const checkIsLogin = () => {
    const token = store.state.user.token;
    return !(!token && !getToken());
  };

  const showPrice = (amount, rate, unit = "日元") => {
    const lang = store.state.user.language || "";
    let price: any = Number(amount);
    if (unit !== "日元") {
      price = amount * rate;
      unit = lang == "zh-CN" ? "元" : "NTD";
    }

    price = Number.isInteger(price)
      ? formatThousand(price.toString())
      : price.toFixed(2);

    return {
      price,
      unit,
    };
  };

  return {
    JumpTo,
    JumpToHref,
    checkLoginAndJump,
    checkIsLogin,
    showPrice,
    checkLoginOpen,
  };
}
